if (process.env.NODE_ENV === 'development') {
  console.log('flutter.utilities loaded');
}
// addLoadingSpinner - Adds a loading spinner to the target
// @param {object} $target - The target to add the loading spinner to, passed as a jQuery object
// @returns {void
export function addLoadingSpinner($target) {
  if (typeof $target === 'undefined') {
    return;
  }
  if ($target.length == 0) {
    return;
  }
  const svg = `<svg class="spinner" viewBox="0 0 50 50" width="50px" height="50px">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>`
  const wrapperWidth = $target.width();
  const wrapperHeight = $target.height();
  const $spinner = $('<div class="flutter-loader" style="height:' + wrapperHeight + 'px; width:' + wrapperWidth + 'px;"><div class="spinner" >' + svg + '</div></div>');
  $target.append($spinner);
}
// getDayAfterDate - Gets the date after the specified date
// @param {string} date - The date to get the day after
// @returns {string} - The date after the specified date
//const moment = await import('moment');
export function getDayAfterDate(date, moment) {
  return moment(new Date(new Date(date).setDate(new Date(date).getDate() + 1))).format('YYYY-MM-DD')
}

// removeLoadingSpinner - Removes the loading spinner from the target
// @param {object} $target - The target to remove the loading spinner from, passed as a jQuery object
// @returns {void}
export function removeLoadingSpinner($target) {
  if ($target.length == 0) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('flutter.utils: removeLoadingSpinner: No target found', $target);
    }
  }
  const $loader = $target.find('.flutter-loader');
  if ($loader.length == 0) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('flutter.utils: removeLoadingSpinner: No loader found', $target);
    }
    return;
  }
  $loader.fadeOut(250).remove();
}
const $window = $(window);
// isDesktop - Determines if the current window is a desktop window
// @param {number} mobileBreakpoint (optional) - The breakpoint at which the window is considered a desktop window. Default is 1024
// @returns {boolean} - True if the window is a desktop window
export function isDesktop(mobileBreakpoint = 1024) {
  return $window.width() > mobileBreakpoint;
}
// This is used across multiple widgets
// @param {object} eventData - The event data to process
export function handleProceedToPay(eventData,index = 0) {
  const orderId = eventData; // This should just be an order ID, no JSON
  window.location = '/checkout?orderId=' + orderId + '&index=' + index;
}
// Capitalize Word - Capitalizes the first letter of a word
// @param {string} word - The word to capitalize
// @returns {string} - The capitalized word
export function capitalizeWord(word) {
  if (typeof word === 'undefined') return null
  if (word == null) return null;
  if (word.length == 0) return word;
  return word.charAt(0).toUpperCase() + word.slice(1);
}
// sendToGa4 - Sends an event to Google Analytics 4
// @param {object} object - The object to send to GA4 - should already be deserialized
export function sendToGa4(object) {
  if(process.env.NODE_ENV === 'development') {
    console.log('sendToGa4', object);
  }
  window.dataLayer = window.dataLayer || [] // Create a data layer
  dataLayer.push({ ecommerce: null }); // Clear previous ecommerce object
  dataLayer.push(object)
}

// resizeFrame - Resizes a div and its child iframe to the specified width and height
// @param {string} $target - The target element to resize, passed as a jQuery object
// @param {number} width - The new width
// @param {number} height - The new height
// @param {number} minHeight - The minimum height
// @param {number} heightBuffer (optional) - The buffer to add to the height below the widget. Default is 15
// @returns {void}
export function resizeFrame($target, width, height, minHeight, heightBuffer = 15) {
  if (process.env.NODE_ENV === 'development') {
    console.log('flutter.utils.resizeFrame: resizing frame', { target: $target, width: width, height: height });
  }
  if (height < minHeight) {
    if (process.env.NODE_ENV === 'development') {
      console.warn("flutter.utils.resizeFrame: Not resizing, height < minHeight " + $target.attr('id') + " height: " + height + ", minHeight" + minHeight);
      height = minHeight;
    }
  }
  if ($target.length >= 1) {
    if (process.env.NODE_ENV === 'development') {
      console.log("flutter.utils.resizeFrame: Resizing " + $target.attr('id') + " to " + width + "x" + height);
    }

    $target.css('height', height + heightBuffer);
    //$target.css('width', width); // Width isn't necessary for some frames, will need to dynamically do this based on target I think

    const $iframe = $target.children('iframe');
    if ($iframe.length >= 1) {
      $iframe.css('height', height + heightBuffer);
      //$iframe.css('width', width);
    } else {
      if (process.env.NODE_ENV === 'development') {
        //debugger;
      }
      console.warn("flutter.events.resizeFrame: No child iframe found for resizeFrame", $target, $iframe);
    }
  } else {
    console.warn("flutter.events.resizeFrame: No target found for resizeFrame", $target);
  }
}

// parseJSONRecursively - Sometimes events are parsed twice, and require multiple parsing
// This function will attempt to parse the payload multiple times until it's a valid object
// @param {string} payload - The payload to parse
// @returns {object} - The parsed object
// @returns {string} - The original payload if it's not valid JSON
export function parseJSONRecursively(payload) {
  // Sanity checking prior to parsing
  if (payload === null || payload === undefined || payload === "") {
    return payload;
  }
  try {
    // Attempt to parse the payload
    const parsed = JSON.parse(payload);

    // If the parsed result is a string, it might be another JSON object
    if (typeof parsed === 'string') {
      // Recursively try to parse it again
      return parseJSONRecursively(parsed);
    } else {
      // If it's not a string, we've reached the final parsed object
      return parsed;
    }
  } catch (error) {
    console.warn('flutter.utils.parseJSONRecursively: Error parsing JSON payload, probably not JSON', payload, error);
    // If it's not valid JSON, return the original payload
    return payload;
  }
}
const stateAbbreviationMap = {
  "new-south-wales": "NSW",
  "queensland": "QLD",
  "victoria": "VIC",
  "south-australia": "SA",
  "western-australia": "WA",
  "aust-capital-territory": "ACT",
  "northern-territory": "NT",
  "tasmania": "TAS"
}
// getStateAbbreviationFromURLPath - Gets the state abbreviation from a URL path
// @param {string} stateSlug - The state slug to get the abbreviation for
// @returns {string} - The state abbreviation
export function getStateAbbreviationFromURLPath(stateSlug) {
  if (stateAbbreviationMap[stateSlug]) {
    return stateAbbreviationMap[stateSlug];
  } else {
    if (process.env.NODE_ENV === 'development') {
      console.warn('flutter.utils.getStateAbbreviationFromURLPath: No abbreviation found for state', stateSlug);
    }
  }
}
